import { Global, css } from '@emotion/react'

export function GlobalStyles() {
  return (
    <Global
      styles={css`
        /* ── เปลี่ยนมาใช้ชุดฟอนต์ของ JWC14 ── */
        body {
          font-family: var(--font-inter), var(--font-ibm-thai), -apple-system, BlinkMacSystemFont,
            'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans',
            'Helvetica Neue', sans-serif;
          font-weight: 400;
          background: transparent; 
        }

        .ant-calendar-picker-input,
        .ant-calendar-picker {
          width: 100%;
        }

        h4.ant-typography {
          font-family: var(--font-ibm-thai-looped), sans-serif;
          line-height: 1.9;
          color: #ffffff; 
        }

        .ant-form-item {
          margin-bottom: 32px;
        }

        /* ── ปรับ Label ของฟอร์มให้เป็นฟอนต์ JWC14 และเป็นสีขาว ── */
        .ant-form-item-label > label {
          font-size: 18px;
          font-family: var(--font-ibm-thai), sans-serif;
          font-weight: 600;
          color: #ffffff !important; 
        }

        /* ── ปรับฟอนต์ในช่องกรอกข้อมูล ── */
        .ant-form-item-children > textarea,
        .ant-input {
          font-family: var(--font-ibm-thai), sans-serif;
          line-height: 1.8;
          font-size: 16px;
        }
      `}
    />
  )
}
